import { Link } from '@ctw/shared/components/link';
import { useCTW } from '@ctw/shared/context/ctw-context';
import { usePatientContextIfAvailable } from '@ctw/shared/context/patient-provider';
import { type ClassName, twx } from '@ctw/shared/utils/tailwind';
import { useMemo } from 'react';

const ZendeskCustomFields = {
  patientUpid: '40486964326939',
  ehr: '40444266842651',
  builderName: '40696131382811',
};

interface SupportFormUrlOptions {
  patientUpid?: string;
  builderName?: string;
  email?: string;
  ehr?: string;
}

export const supportFormUrl = ({ builderName, email, patientUpid, ehr }: SupportFormUrlOptions) => {
  const url = new URL(
    'https://zushealth-90303.zendesk.com/hc/en-us/requests/new?ticket_form_id=45712768788379',
  );
  if (patientUpid && patientUpid.length > 0) {
    url.searchParams.set(`tf_${ZendeskCustomFields.patientUpid}`, patientUpid);
  }
  if (ehr && ehr.length > 0) {
    url.searchParams.set(`tf_${ZendeskCustomFields.ehr}`, ehr);
  }
  if (builderName && builderName.length > 0) {
    url.searchParams.set(`tf_${ZendeskCustomFields.builderName}`, builderName);
  }
  if (email && email.length > 0) {
    url.searchParams.set('tf_anonymous_requester_email', email);
  }

  return url;
};

interface SupportFormLinkProps {
  buttonText: string;
  className?: ClassName;
}

export const SupportFormLink = ({
  buttonText,
  className = 'link text-sm',
}: SupportFormLinkProps) => {
  const { requestContext } = useCTW();
  const patientContext = usePatientContextIfAvailable();
  const url = useMemo(
    () =>
      supportFormUrl({
        builderName: requestContext.authTokenState.builderName,
        email: requestContext.authTokenState.email,
        patientUpid: patientContext?.patient?.UPID,
        ehr: requestContext.ehr,
      }),
    [
      requestContext.authTokenState.builderName,
      requestContext.authTokenState.email,
      requestContext.ehr,
      patientContext?.patient?.UPID,
    ],
  );

  return (
    <Link
      href={url.toString()}
      className={twx(
        'focus:outline-4 focus:outline-primary-main focus:outline-offset-[3px] focus-visible:outline-4 focus-visible:outline-primary-main focus-visible:outline-offset-[3px]',
        className,
      )}
      target="_blank"
    >
      {buttonText}
    </Link>
  );
};
